import DeleteIcon from '@mui/icons-material/Delete'
import { FC } from 'react'
import type { Feature } from 'geojson'
import { useMapContext } from './MapContext'
import { FloatingActionButtons } from './FloatingActionButtons'

interface DeleteMultiPolygonButtonProps {
  selectedFeature?: Feature | null
}

/**
 * A floating action button that toggles the display of delete markers for MultiPolygon features.
 * Only renders if the selectedFeature has a MultiPolygon geometry.
 */
export const DeleteMultiPolygonButton: FC<DeleteMultiPolygonButtonProps> = ({
  selectedFeature,
}) => {
  const { showDeletePolygons, setShowDeletePolygons } = useMapContext()

  if (!selectedFeature || selectedFeature.geometry?.type !== 'MultiPolygon') {
    return null
  }

  return (
    <FloatingActionButtons.Button
      color={showDeletePolygons ? 'error' : 'primary'}
      title="Eliminar geometrías dentro de la capa"
      onClick={() => setShowDeletePolygons?.(v => !v)}
    >
      <DeleteIcon />
    </FloatingActionButtons.Button>
  )
}
